import { useState } from "react";
import Icon from "../Icon";
import useTranslations from "../../../core/i18n/useTranslations";
import { Row, Spacer } from "../../../components/Layout/Layout";
import PrimeTooltip from "../PrimeTooltip/PrimeTooltip";

import styles from "./CopyToClipboard.module.css";

export const CopyToClipboard = ({
  prefilledText,
  text,
}: {
  text: string;
  prefilledText?: string;
}) => {
  const t = useTranslations();

  const [isCopied, setIsCopied] = useState(false);

  const delay = (time: number) =>
    new Promise((resolve) => setTimeout(resolve, time));

  const copyIcon = (
    <span>
      <Icon
        id="copy"
        className={styles.copyIcon}
        name="document-duplicate"
        onClick={async () => {
          setIsCopied(true);
          await navigator.clipboard.writeText(
            prefilledText ? `${prefilledText}${text}` : text
          );
          await delay(1000);
          setIsCopied(false);
        }}
        size={18}
        color="Primary-700"
        hoverEffect
      />
    </span>
  );

  if (!("clipboard" in navigator)) return;

  return (
    <>
      {copyIcon}
      <PrimeTooltip
        target="#copy"
        theme={isCopied ? "dark" : "light"}
        content={
          isCopied ? (
            <Row>
              <Icon name="check-circle" size={16} />
              <Spacer size={6} />
              {t("Common:copied")}
            </Row>
          ) : (
            t("Common:copy_to_clipboard")
          )
        }
      />
    </>
  );
};
